<template>
  <div
    v-if="content"
    class="rich-text-block"
    v-html="content"
    @click="imagePreview"
  ></div>
</template>

<script>
/**
 * 富文本显示组件
 */
// xss过滤
const xssFilter = (html) => {
  let result = html;
  if (!result) return '';
  // 将script标签过滤
  result = result.replace(/<\s*\/?script\s*>/, '');
  // 过滤result标签中存在的javascript所执行的内容
  result = result.replace(/javascript:[^'"]*/g, '');
  // 过滤result标签中所执行的脚本
  result = result.replace(/onerror\s*=\s*['"]?[^'"]*['"]?/g, '');
  return result;
};

// 格式化转化html
const formatHtml = (html) => {
  let result = html;
  if (!result) return '';
  // 转化↵等换行
  result = result.replace(/(\r\n|\n|\r|↵)/gm, '');

  return result;
};

export default {
  name: 'RichText',
  props: {
    value: String,
  },
  data() {
    return {
      imageUrls: [],
    };
  },
  mounted() {
    const patt = /<img[^>]+src=['"]([^'"<>]+)['"]+/g;
    let temp = patt.exec(this.value);
    while (temp !== null) {
      this.imageUrls.push(temp[1]);
      temp = patt.exec(this.value);
    }
  },
  computed: {
    content() {
      let html = xssFilter(this.value);
      html = formatHtml(html);
      return html;
    },
  },
  methods: {
    imagePreview(e) {
      if (e.target.nodeName === 'IMG') {
        this.$viewer.start({
          urls: this.imageUrls, currentIndex: this.imageUrls.indexOf(e.target.currentSrc),
        });
      }
    },
  },
};
</script>

<style lang="less">
  .rich-text-block {
    word-wrap: break-word;
    img {
      max-width: 100%;
      height: auto !important;
    }
    video {
      width: 100%;
      height: auto !important;
    }
  }
</style>
